import { useChannelConfigurations } from '../_internal/hooks/useChannelConfigurations';
export { useChannelConfigurations };